import { Check, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { money, priceOf, yearlySaving } from "@/lib/plan";

export function PlanCard({ plan: p, cycle, cta, onClick, busy, index, currency: cur }) {
  const dark = p.recommended;
  const price = priceOf(p, cycle, cur);
  const monthly = priceOf(p, "monthly", cur);
  const save = yearlySaving(p, cur);
  return (
    <div data-testid={`plan-card-${p.id}`} style={{ animationDelay: `${index * 90}ms` }}
      className={`relative flex flex-col rounded-3xl border p-7 animate-in fade-in slide-in-from-bottom-4 fill-mode-both duration-500 transition-transform hover:-translate-y-1 ${dark ? "border-brand bg-band text-white shadow-2xl shadow-[var(--navy)]/25 lg:-my-4 lg:py-11" : "border-line bg-surface"}`}>
      {dark && <span data-testid="plan-recommended-badge" className="absolute -top-3.5 left-7 inline-flex items-center gap-1.5 rounded-full bg-[var(--brand-cyan)] px-3 py-1 text-xs font-bold text-[#0B1220]"><Sparkles className="h-3.5 w-3.5" />Recommended</span>}
      <h3 className={`font-display text-xl font-extrabold ${dark ? "text-white" : "text-ink"}`}>{p.name}</h3>
      <p className={`mt-1 min-h-[40px] text-sm ${dark ? "text-slate-300" : "text-ink-3"}`}>{p.tagline}</p>
      <div className="mt-6 flex items-end gap-1.5">
        <span data-testid={`plan-price-${p.id}`} className="font-display text-5xl font-extrabold tracking-tight">{money(price, cur)}</span>
        <span className={`pb-1.5 text-sm ${dark ? "text-slate-300" : "text-ink-3"}`}>/{cycle === "yearly" ? "year" : "month"}</span>
      </div>
      <p className={`mt-2 h-5 text-xs font-semibold ${dark ? "text-[var(--brand-cyan)]" : "text-aqua"}`}>
        {monthly > 0 && (cycle === "yearly" ? `Works out to ${money(Math.round(priceOf(p, "yearly", cur) / 12), cur)}/month${save ? ` · save ${save}%` : ""}` : `or ${money(priceOf(p, "yearly", cur), cur)}/year${save ? ` (save ${save}%)` : ""}`)}
        {monthly === 0 && "Free forever, no card needed"}
      </p>
      <Button data-testid={`plan-cta-${p.id}`} onClick={onClick} disabled={cta.disabled || busy}
        className={`mt-6 h-11 rounded-full font-semibold transition-transform active:scale-[0.98] ${dark ? "bg-[var(--brand-cyan)] text-[#0B1220] hover:bg-white" : p.id === "free" ? "bg-surface text-ink ring-1 ring-line-strong hover:bg-canvas-2" : "bg-solid text-white hover:bg-solid-hover"}`}>
        {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{cta.label}
      </Button>
      <ul className="mt-7 flex flex-col gap-3 text-sm">
        {p.features.map((f, i) => (
          <li key={i} data-testid={`plan-feature-${p.id}-${i}`} className="flex gap-2.5">
            <Check className={`mt-0.5 h-4 w-4 shrink-0 ${dark ? "text-[var(--brand-cyan)]" : "text-aqua"}`} />
            <span className={dark ? "text-slate-100" : "text-ink-2"}>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
